
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"35","height":"62","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.648 35.5v-.492c.568 0 .917-.034 1.047-.102.13-.073.195-.281.195-.625v-8.32c0-.396-.07-.643-.21-.742-.136-.1-.48-.149-1.032-.149v-.5l2.297-.172v9.883c0 .344.068.552.203.625.135.068.484.102 1.047.102v.492c-.13 0-.33-.005-.602-.016-.27-.01-.505-.018-.703-.023a18.874 18.874 0 00-.469-.008c-.125 0-.716.016-1.773.047zm4.422 0v-.492c.568 0 .916-.034 1.047-.102.13-.073.195-.281.195-.625v-4.289c0-.396-.07-.643-.21-.742-.136-.099-.48-.148-1.032-.148v-.5l2.25-.172v1.68c.5-1.12 1.289-1.68 2.367-1.68.802 0 1.362.198 1.68.593.234.266.375.547.422.844.052.297.078.83.078 1.602v3.054c.01.224.101.362.273.414.172.047.497.07.977.07v.493a158.974 158.974 0 00-1.797-.047c-.084 0-.685.016-1.805.047v-.492c.568 0 .917-.034 1.047-.102.135-.073.203-.281.203-.625v-3.726c0-.542-.083-.972-.25-1.29-.167-.322-.479-.484-.937-.484-.552 0-1.05.232-1.493.696-.442.463-.664 1.085-.664 1.867v2.937c0 .344.065.552.196.625.135.068.484.102 1.047.102v.492a164.248 164.248 0 00-1.79-.047c-.083 0-.684.016-1.804.047z","fill":"currentColor"}}),_c('rect',{attrs:{"x":"19.273","y":"25.5","width":"15","height":"11","rx":"1.5","stroke":"currentColor","stroke-dasharray":"4 4"}})])
          )
        }
      }
    